export enum Icons {
  ARROW_UP = 'ARROW_UP',
  CLOSE = 'CLOSE',
  INFO = 'INFO',
}
